import { Dispatch, MouseEvent, SetStateAction } from 'react';
import styles from './style.module.scss';
import { CheckIcon } from '../../assets/icons';

interface Props {
    text?: string;
    checked: boolean;
    className?: string;
    onClick?: (_?: any) => void;
    setChecked?: Dispatch<SetStateAction<boolean>>;
};

function CheckBox(props: Props) {
    const { text, checked, className, setChecked, onClick } = props;

    const click = (e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        e.preventDefault();
        onClick && onClick();
        setChecked && setChecked(!checked);
    };

    return (
        <div className={`${styles.wrapper} ${className || ''}`} onClick={click}>
            <div className={styles.checkBox} data-checked={checked}>
                {checked && <CheckIcon width={10} height={10} strokeWidth={3} stroke='#ffffff' />}
            </div>
            <span className={styles.text}>{text}</span>
        </div>
    );
};

export default CheckBox;
